import * as React from 'react';
import {useTranslation} from "react-i18next";

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Checkbox,
    Dialog,
    DialogContent,
    FormControl,
    FormControlLabel,
    Radio,
    RadioGroup,
    Tab,
    Tabs,
    Typography
} from "@mui/material";
import {ArrowCircleLeft, ExpandMore, GppGood} from "@mui/icons-material";
import {convertPrice} from "../../assets/js/main";
import {useDispatch, useSelector} from "react-redux";
import {useSnackbar} from "notistack";
import HandleFetchData from "../../plugin/HandleFetchData";
// import {setInfoBox} from "../../redux/singleOrder/infoBox/actions";
import CancelIcon from "@mui/icons-material/Cancel";
import Divider from "@mui/material/Divider";


export default function Invoice(props) {
    const {t} = useTranslation()
    const {enqueueSnackbar} = useSnackbar();
    const {fetchData} = HandleFetchData()

    const dispatch = useDispatch();
    const selector = useSelector((st) => st)
    const [expanded, setExpanded] = React.useState(1);
    const [showDetails, setShowDetails] = React.useState(true);
    const [showAccordion, setShowAccordion] = React.useState(true);
    const [payMethods, setPayMethods] = React.useState([]);
    const [rulesDialog1, setRulesDialog1] = React.useState(false)
    const [value, setValue] = React.useState('0');
    const rulesItem = [
        {
            label: 'rules.s1.t1',
            items: [
                'rules.s1.t2',
                'rules.s1.t3',
                'rules.s1.t4',
                'rules.s1.t5',
                'rules.s1.t6',
                'rules.s1.t7',
                'rules.s1.t8',
                'rules.s1.t9',
                'rules.s1.t10',
                'rules.s1.t11',
                'rules.s1.t12',
                'rules.s1.t13',
                'rules.s1.t14',
                'rules.s1.t15',
                'rules.s1.t16',
                'rules.s1.t17',
                'rules.s1.t18',
                'rules.s1.t19',
                'rules.s1.t20',
            ]
        },
        {
            label: 'rules.s2.t1',
            items: [
                'rules.s2.t2',
                'rules.s2.t3',
                'rules.s2.t4',
                'rules.s2.t5',
                'rules.s2.t6',
                'rules.s2.t7',
                'rules.s2.t8',
            ]
        },
        {
            label: 'rules.s3.t1',
            items: [
                'rules.s3.t2',
                'rules.s3.t3',
                'rules.s3.t4',
                'rules.s3.t5',
                'rules.s3.t6',
            ]
        },
    ]

    const handleChange = (event) => {
        props.handlePaymentMethod(event.target.value)
    };

    const handleChangeRule = (event, newValue) => {
        setValue(newValue);
    };

    React.useEffect(() => {
        props?.items?.orderId && getPaymentMethods(props?.items?.orderId)
    }, [props])

    const getPaymentMethods = async (id) => {
        let fetch = await fetchData('', 'GET', '/getPaymentMethod', '',
            "application/json", {
                "orderId": String(id),
                "paymentMethodForId": "1"
            }, '', ''
        )
        if (fetch?.Data) {
            setPayMethods(fetch?.Data)
        }
    }


    const handleItemsPrice = (items) => {
        return items?.AccessPrinterPrice + items?.AgentAddedValue + items?.CartonPrice + items?.CodTranPrice + items?.DistributionPrice + items?.GoodsCodPrice + items?.InsurancePrice + items?.PrintLogoPrice + items?.RegistrationValue + items?.SmsPrice + items?.shipmentHaghemaghar
    }

    return (
        <>
            {/*<div className="container">*/}
            <div className="invoicePage">

                {props?.paymentMethod && <div style={{visibility: "hidden", opacity: "0"}} id="isSelectPaymentMethod"/>}

                <div className="row">
                    <div className="col-12 col-lg-4 mb-3">
                        <div className="paymentInfo">
                            <div className="info">
                                <div className="orderNum">
                                    <p>{t("singleOrder.invoice.t2")} :</p>
                                    <span>{props?.items?.orderId}</span>
                                </div>
                                <div className="orderTotal">
                                    <p>{
                                        props?.items?.shipmentsData[0]?.Discount ?
                                            t("singleOrder.invoice.t51")
                                            :
                                            t("singleOrder.invoice.t13")
                                    } :</p>
                                    <span>{
                                        props?.items?.shipmentsData[0]?.Discount ?
                                            convertPrice(props?.items?.orderTotal - props?.items?.shipmentsData[0]?.Discount)
                                            :
                                            convertPrice(props?.items?.orderTotal)
                                    } {t("singleOrder.invoice.t14")}</span>
                                </div>
                            </div>

                            <FormControl>
                                <RadioGroup
                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                    name="controlled-radio-buttons-group"
                                    value={props?.paymentMethod}
                                    onChange={handleChange}
                                    id="paymentMethod"
                                >
                                    {
                                        payMethods?.PaymentMethods?.map((item, index) =>
                                            item?.Name !== "بانک سامان" &&
                                            <FormControlLabel value={item?.PaymentMethodSystemName} control={<Radio/>}
                                                              label={item?.Name + ' ' + `${item?.PaymentMethodSystemName === "Payments.Wallet"
                                                                  ? `( ${(payMethods?.RewardPointsBalance ?
                                                                      convertPrice(payMethods?.RewardPointsBalance) : 0) + ' ' + t("singleOrder.invoice.t14")} )` : ''}`}/>
                                        )
                                    }
                                </RadioGroup>
                            </FormControl>

                        </div>
                        <div className="d-inline-block m-0">
                            <div className="d-flex mb-3">
                                <Checkbox checked={props?.checkedRules}
                                          onChange={(e) => props?.handleSetCheckedRules(e.target.checked)}
                                          id="checkedRules"/>
                                <div className="_btnGroup_light">
                                    <button className="btnEmpty" onClick={() => {
                                        setRulesDialog1(true)
                                        props?.handleSetCheckedRules(true)
                                    }} id="checkedRules">
                                        <span>مطالعه قوانین</span>
                                        <ArrowCircleLeft/>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-12 col-lg-8">
                        <div className="orderInfo">
                            <Accordion expanded={showAccordion} onChange={() => setShowAccordion(!showAccordion)}>
                                <AccordionSummary aria-controls="panel1d-content" id="panel1d-header"
                                                  expandIcon={<ExpandMore/>}>
                                    <Typography>{t("singleOrder.invoice.t3")}</Typography>
                                </AccordionSummary>
                                <AccordionDetails>

                                    <div className="postService mb-4">
                                        <div className="title">
                                            <h6>{t("singleOrder.invoice.t4")}</h6>
                                        </div>
                                        <table>
                                            <thead>
                                            <tr>
                                                {/*<th style={{width: '10%'}}>{t("singleOrder.invoice.t5")}</th>*/}
                                                {/*<th style={{width: '10%'}}/>*/}
                                                <th style={{width: '60%'}}>{t("singleOrder.invoice.t6")}</th>
                                                <th style={{width: '20%'}}/>
                                                <th style={{width: '20%'}}>{t("singleOrder.invoice.t8")}</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {
                                                selector?.single_review?.listReview?.map((item, index) => {
                                                    return <tr className="bodyTable">
                                                        {/*<td/>*/}
                                                        <td>{item?.SLA?.ServiceName}</td>
                                                        <td/>
                                                        <td>{convertPrice(props?.items?.shipmentsData[index]?.gatewayPostPrice + props?.items?.shipmentsData[index]?.PostexEngPrice)}</td>
                                                    </tr>
                                                })
                                            }
                                            {props?.items?.shipmentsData?.map((item, index) =>
                                                <tr className="bodyTable">
                                                    {/*<td/>*/}
                                                    <td>{t("singleOrder.invoice.t20")}</td>
                                                    <td/>
                                                    <td>{convertPrice(item?.gatewayPostPriceTax || 0)}</td>
                                                </tr>
                                            )
                                            }

                                            <tr className="bodyTable btnBodyTable">
                                                {/*<td/>*/}
                                                <td>{t("singleOrder.invoice.t9")}</td>
                                                <td/>
                                                <td>{convertPrice(props?.items?.shipmentsData[0]?.gatewayPostPrice + props?.items?.shipmentsData[0]?.PostexEngPrice + props?.items?.shipmentsData[0]?.gatewayPostPriceTax)}</td>
                                            </tr>


                                            </tbody>
                                        </table>
                                    </div>


                                    <div className="postService">
                                        <div className="title">
                                            <h6>{t("singleOrder.invoice.t11")}</h6>
                                        </div>
                                        {
                                            props?.items?.shipmentsData?.map((item, index) => {
                                                return <table>
                                                    <thead>
                                                    <tr>
                                                        {/*<th style={{width: '10%'}}>{t("singleOrder.invoice.t5")}</th>*/}
                                                        {/*<th style={{width: '10%'}}/>*/}
                                                        <th style={{width: '60%'}}>{t("singleOrder.invoice.t6")}</th>
                                                        <th style={{width: '20%'}}/>
                                                        <th style={{width: '20%'}}>{t("singleOrder.invoice.t8")}</th>
                                                    </tr>
                                                    </thead>
                                                    <tbody>

                                                    {
                                                        showDetails ?
                                                            <>
                                                                {
                                                                    item?.AccessPrinterPrice ?
                                                                        <tr className="bodyTable">
                                                                            {/*<td/>*/}
                                                                            <td>{t("singleOrder.invoice.t21")}</td>
                                                                            <td/>
                                                                            <td>{convertPrice(item?.AccessPrinterPrice)}</td>
                                                                        </tr>
                                                                        : null
                                                                }

                                                                {
                                                                    item?.AgentAddedValue ?
                                                                        <tr className="bodyTable">
                                                                            {/*<td/>*/}
                                                                            <td>{t("singleOrder.invoice.t22")}</td>
                                                                            <td/>
                                                                            <td>{convertPrice(item?.AgentAddedValue)}</td>
                                                                        </tr> : null
                                                                }

                                                                {
                                                                    item?.CartonPrice ?
                                                                        <tr className="bodyTable">
                                                                            {/*<td/>*/}
                                                                            <td>{t("singleOrder.invoice.t23")}</td>
                                                                            <td/>
                                                                            <td>{convertPrice(item?.CartonPrice)}</td>
                                                                        </tr> : null
                                                                }

                                                                {
                                                                    item?.CodTranPrice ?
                                                                        <tr className="bodyTable">
                                                                            {/*<td/>*/}
                                                                            <td>{t("singleOrder.invoice.t24")}</td>
                                                                            <td/>
                                                                            <td>{convertPrice(item?.CodTranPrice)}</td>
                                                                        </tr> : null
                                                                }
                                                                {
                                                                    item?.DistributionPrice ?
                                                                        <tr className="bodyTable">
                                                                            {/*<td/>*/}
                                                                            <td>{t("singleOrder.invoice.t25")}</td>
                                                                            <td/>
                                                                            <td>{convertPrice(item?.DistributionPrice)}</td>
                                                                        </tr> : null
                                                                }
                                                                {
                                                                    item?.GoodsCodPrice ?
                                                                        <tr className="bodyTable">
                                                                            {/*<td/>*/}
                                                                            <td>{t("singleOrder.invoice.t26")}</td>
                                                                            <td/>
                                                                            <td>{convertPrice(item?.GoodsCodPrice)}</td>
                                                                        </tr> : null
                                                                }
                                                                {
                                                                    item?.InsurancePrice ?
                                                                        <tr className="bodyTable">
                                                                            {/*<td/>*/}
                                                                            <td>{t("singleOrder.invoice.t27")}</td>
                                                                            <td/>
                                                                            <td>{convertPrice(item?.InsurancePrice)}</td>
                                                                        </tr> : null
                                                                }
                                                                {/*{*/}
                                                                {/*  item?.PostexEngPrice ?*/}
                                                                {/*     <tr className="bodyTable">*/}
                                                                {/*       /!*<td/>*!/*/}
                                                                {/*       <td>{t("singleOrder.invoice.t28")}</td>*/}
                                                                {/*       <td/>*/}
                                                                {/*       <td>{convertPrice(item?.PostexEngPrice)}</td>*/}
                                                                {/*     </tr> : null*/}
                                                                {/*}*/}
                                                                {
                                                                    item?.PrintLogoPrice ?
                                                                        <tr className="bodyTable">
                                                                            {/*<td/>*/}
                                                                            <td>{t("singleOrder.invoice.t29")}</td>
                                                                            <td/>
                                                                            <td>{convertPrice(item?.PrintLogoPrice)}</td>
                                                                        </tr> : null
                                                                }
                                                                {
                                                                    item?.RegistrationValue ?
                                                                        <tr className="bodyTable">
                                                                            {/*<td/>*/}
                                                                            <td>{t("singleOrder.invoice.t30")}</td>
                                                                            <td/>
                                                                            <td>{convertPrice(item?.RegistrationValue)}</td>
                                                                        </tr> : null
                                                                }
                                                                {
                                                                    item?.SmsPrice ?
                                                                        <tr className="bodyTable">
                                                                            {/*<td/>*/}
                                                                            <td>{t("singleOrder.invoice.t31")}</td>
                                                                            <td/>
                                                                            <td>{convertPrice(item?.SmsPrice)}</td>
                                                                        </tr> : null
                                                                }
                                                                {
                                                                    item?.shipmentHaghemaghar ?
                                                                        <tr className="bodyTable">
                                                                            {/*<td/>*/}
                                                                            <td>{t("singleOrder.invoice.t32")}</td>
                                                                            <td/>
                                                                            <td>{convertPrice(item?.shipmentHaghemaghar)}</td>
                                                                        </tr> : null
                                                                }
                                                                {/*{*/}
                                                                {/*  item?.Discount ?*/}
                                                                {/*      <tr className="bodyTable">*/}
                                                                {/*        /!*<td/>*!/*/}
                                                                {/*        <td>{t("singleOrder.invoice.t50")}</td>*/}
                                                                {/*        <td/>*/}
                                                                {/*        <td>{convertPrice(item?.Discount)}</td>*/}
                                                                {/*      </tr> : null*/}
                                                                {/*}*/}

                                                                {/*<tr className="bodyTable">*/}
                                                                {/*  <td/>*/}
                                                                {/*  <td/>*/}
                                                                {/*  <td>{t("singleOrder.invoice.t9")}</td>*/}
                                                                {/*  <td>{convertPrice(handleItemsPrice(item))}</td>*/}
                                                                {/*</tr>*/}
                                                            </>
                                                            : null
                                                    }

                                                    <tr className="bodyTable btnBodyTable"
                                                        onClick={() => setShowDetails(!showDetails)}>
                                                        {/*<td/>*/}
                                                        <td>{showDetails ? t("singleOrder.invoice.t9") : t("singleOrder.invoice.t19")}</td>
                                                        <td/>
                                                        <td>{convertPrice(handleItemsPrice(item))}</td>
                                                    </tr>


                                                    </tbody>
                                                </table>
                                            })
                                        }
                                    </div>

                                    <table>
                                        <thead>
                                        {props?.items?.shipmentsData[0]?.Discount ?
                                            <tr style={{height: '40px'}}>
                                                <th style={{width: '60%'}}>{t("singleOrder.invoice.t50")}</th>
                                                <th style={{width: '20%'}}/>
                                                <th style={{width: '20%'}}>{convertPrice(props?.items?.shipmentsData[0]?.Discount)} {t("singleOrder.invoice.t14")}</th>
                                            </tr>
                                            : null
                                        }

                                        <tr style={{height: '40px'}}>
                                            <th style={{width: '60%'}}>{
                                                props?.items?.shipmentsData[0]?.Discount ?
                                                    t("singleOrder.invoice.t51")
                                                    :
                                                    t("singleOrder.invoice.t13")
                                            }</th>
                                            <th style={{width: '20%'}}/>
                                            <th style={{width: '20%'}}>{
                                                props?.items?.shipmentsData[0]?.Discount ?
                                                    convertPrice(props?.items?.orderTotal - props?.items?.shipmentsData[0]?.Discount)
                                                    :
                                                    convertPrice(props?.items?.orderTotal)
                                            } {t("singleOrder.invoice.t14")}</th>
                                        </tr>
                                        </thead>
                                    </table>

                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
            <Dialog
                fullScreen
                open={rulesDialog1}
                onClose={() => setRulesDialog1(false)}
                className="dialog-rules"
            >

                <div className="_closed">
                    <img src={process.env.REACT_APP_SITE === 'amnito' ? '/amnito.png' : '/Logo.png'} alt="Logo"
                         loading="lazy"/>

                    <button type="button" onClick={() => setRulesDialog1(false)} id="closeRulesDialog1">
                        <CancelIcon/>
                    </button>

                </div>

                <DialogContent dividers={true}>

                    <div className="container pb-5">
                        <div className="row">
                            {/*<div className="col-0 col-md-3 col-lg-4"/>*/}
                            <div className="col-12 text-right">

                                {
                                    selector?.single_info_box?.payment_type === "amnito" ?
                                        <div>
                                            <h3>قوانین امنیتو</h3>
                                            <p>فروشنده گرامی توجه داشته باشید که سه درصد ارزش کالا و خدمات پستی در ازای
                                                هر سفارش تایید شده
                                                از
                                                مبلغ کالا کسر و الباقی مبلغ واریز خواهد شد. </p>
                                            <p>فروشنده محترم تعطیلات رسمی جز روند زمانی ارسال محسوب نمیگردد و شرکت در
                                                قبال آن مسئولیتی
                                                ندارد.</p>

                                            <p>پیشنهاد میشود قبل از ثبت سفارش حتما قوانین کامل امنیتو را مطالعه
                                                کنید!</p>

                                            <Divider/>

                                            <h5 className="mt-4">قوانین سفارش کالا</h5>

                                            <p className="desc-dialog">پستِکس یک بازارگاه خدمات پستی و مالی است که
                                                میتوانید معامله در دیوار
                                                را
                                                بصورت خرید فروش امن و یا پرداخت در محل، با استفاده از انواع سرویس های
                                                پستی، از درب محلی که
                                                هستید
                                                تجربه نمایید.</p>

                                            <Box sx={{width: '100%'}}>
                                                <Tabs
                                                    id="tabs"
                                                    value={value}
                                                    onChange={handleChangeRule}
                                                    textColor="secondary"
                                                    indicatorColor="secondary"
                                                    aria-label="secondary tabs example"
                                                >
                                                    <Tab value="0" label="خریدار"/>
                                                    <Tab value="1" label="فروشنده"/>
                                                </Tabs>


                                                {
                                                    value === '0' && <>
                                                        <ul>
                                                            <li>خریدار محترم لطفاً اطلاعاتی که برای این معامله لازم میباشد
                                                                را جهت شروع فرایند ارسال
                                                                مرسوله
                                                                تکمیل بفرمایید.
                                                            </li>
                                                            <li>خریدار محترم مبلغی که بابت خرید کالا٬ بصورت خرید فروش امن (
                                                                امنیتو ) به حساب امانی
                                                                واریز
                                                                میفرمایید تا زمان تحویل مرسوله و تحویل یا عدم تحویل مرسوله
                                                                در حساب امانی پستِکس باقی
                                                                میماند.
                                                            </li>
                                                            <li>خریدار محترم شما مجاز هستید در زمان تحویل مرسوله محتوای
                                                                مرسوله را در زمان تحویل کنترل
                                                                نمایید و در صورت عدم تطابق با آگهی از تحویل آن خودداری
                                                                ننمایید.
                                                            </li>
                                                            <li>خریدار محترم شما پس از دریافت مرسوله میتوانید در نظرسنجی
                                                                کیفیت کالای خریداری شده و
                                                                سرویس
                                                                دریافت شده شرکت نمایید.
                                                            </li>
                                                            <li>خریدار محترم٬ فروشنده دو روز کاری فرصت دارد تا مرسوله را
                                                                برای شما ارسال نماید و
                                                                چنانچه در
                                                                فرصت یاد شده مرسوله ارسال نگردد وجه امانی ظرف دو روز کاری به
                                                                شما مسترد خواهد گردید
                                                            </li>
                                                            <li>توافق بر سر مبلغ کالا به عهده طرفین معامله میباشد لذا از
                                                                ورود درست اطلاعات مالی و
                                                                فردی
                                                                اطمینان حاصل بفرمایید
                                                            </li>
                                                            <li>خریدار محترم مرسوله شما در مقابل درب ورودی ساختمان و در
                                                                خیابان تحویل داده خواهد شد
                                                            </li>
                                                            <li>برای پرداخت وجه معامله کنسل شده یا کالایی که مورد تایید
                                                                خریدار نمیباشد ارائه شماره
                                                                شبا بنام
                                                                فروشنده الزامی است و در صورت تاخیر در ارائه مسئولیت تاخیر در
                                                                پرداخت بعهده خریدار
                                                                میباشد.
                                                            </li>
                                                            <li>زمان تسویه حساب مالی دو روز کاری می باشد</li>

                                                        </ul>
                                                    </>
                                                }

                                                {
                                                    value === '1' && <>
                                                        <ul>
                                                            <li>چنانچه به هر علت ٬ اعم از عدم شناسایی آدرس و یا برگشتی پس از
                                                                ارسال به باجه معطله
                                                                مرجوع گردد
                                                                کلیه هزینه های پستی و فنی از حساب گیرنده کسر خواهد شدو ارسال
                                                                مجدد و هزینه انبارداری به
                                                                عهده
                                                                فرستنده میباشد
                                                            </li>
                                                            <li>فروشنده محترم لازم است کالای ارسالی مطابق آگهی منتشر شده
                                                                باشد تا در نظر سنجی رضایت
                                                                خریدار
                                                                با نمره منفی مواجه نگردید.
                                                            </li>
                                                            <li>فروشنده محترم تعهد غرامت ناشی از عملیات پستی بعهده پستِکس
                                                                است توجه داشته باشید تشخص
                                                                خسارت
                                                                وارده به عهده کارشناسان خبره بیمه ای پستِکس میباشد و به
                                                                میزان ارزش واقعی مرسوله تعیین
                                                                خواهد
                                                                شد.
                                                            </li>
                                                            <li>فروشنده محترم مرسوله شما در مقابل درب ورودی ساختمان و در
                                                                خیابان تحویل گرفته خواهد
                                                                شد.
                                                            </li>
                                                            <li>برای پرداخت وجه کالا ارائه شماره شبا بنام فروشنده الزامی است
                                                                و در صورت تاخیر در ارائه
                                                                مسئولیت تاخیر در پرداخت بعهده فرستنده میباشد.
                                                            </li>
                                                            <li>فروشنده محترم کلیه مرسولاتی که از ساعت ۸ صبح دیروز تا ساعت ۸
                                                                صبح امروز ثبت میشوند،
                                                                همان روز
                                                                تا ساعت ۱۷ جمع آوری و در فرایند ارسال قرار می گیرند. برای
                                                                روزهای تعطیل فرایند ارسال از
                                                                اولین
                                                                روز کاری شروع می شود.
                                                            </li>
                                                            <li>زمان تسویه حساب مالی دو روز کاری می باشد</li>
                                                        </ul>
                                                    </>
                                                }
                                            </Box>
                                        </div>
                                        :
                                        <div>
                                            <h2>{t("rules.t1")}</h2>
                                            <p>{t("rules.t2")}</p>

                                            <div className="items">
                                                {
                                                    rulesItem?.map((item, index) => {
                                                        return (
                                                            <div className="item" key={index}>
                                                                <h4>{t(item?.label)}</h4>
                                                                <ul>
                                                                    {
                                                                        item?.items?.map((item2, index2) => {
                                                                            return (
                                                                                <li key={index2}>{t(item2)}</li>
                                                                            )
                                                                        })
                                                                    }
                                                                </ul>

                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                }


                                <div className="btnGroup_blue" style={{justifyContent: 'center'}}>
                                    <button type="button" className="btnFill" onClick={() => setRulesDialog1(false)}
                                            id="handleOrderValidate">
                                        <span id="text">متوجه شدم</span>
                                        <GppGood style={{fontSize: '30px', color: '#ffffff'}}/>
                                    </button>
                                </div>
                            </div>
                            {/*<div className="col-0 col-md-3 col-lg-4"/>*/}
                        </div>
                    </div>

                </DialogContent>
            </Dialog>
            {/*</div>*/}
        </>
    )
}
